// extracted by mini-css-extract-plugin
module.exports = {"link":"A_7qw","root":"_3yTlh","label":"WCqiK"};